import type { ComponentType } from 'react';

type SecondarySidebar = ComponentType | null;

interface RouteMatchWithSecondarySidebar {
  id: string;
  staticData: {
    sectionShell?: {
      secondarySidebar?: SecondarySidebar;
    };
  };
}

export interface ActiveRouteSecondarySidebar {
  key: string;
  sidebar: SecondarySidebar;
}

export function findActiveRouteSecondarySidebar(
  matches: readonly RouteMatchWithSecondarySidebar[],
): ActiveRouteSecondarySidebar | undefined {
  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const match = matches[index];
    const sectionShell = match?.staticData.sectionShell;
    if (match && sectionShell && 'secondarySidebar' in sectionShell) {
      return { key: match.id, sidebar: sectionShell.secondarySidebar ?? null };
    }
  }
  return undefined;
}
